import { render, staticRenderFns } from "./NormalSearchNav489.vue?vue&type=template&id=2079fce8&scoped=true&"
import script from "./NormalSearchNav489.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav489.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079fce8",
  null
  
)

export default component.exports